import { AlertTriangle, Download } from '@huspy/briks-icons';
import { Button } from '@huspy/briks-web';
import briksTheme from '@shared/briks-theme';
import Loader from '@shared/loader';
import { useTranslation } from 'react-i18next';

const isDownloadAvailable = false;

type Props = {
  onReportProblemClick: () => void;
};

const BankProductActions = ({ onReportProblemClick }: Props) => {
  const { t } = useTranslation();

  const isPending = false;

  return (
    <>
      <Button variant='secondary' onClick={ onReportProblemClick }>
        <AlertTriangle />
        {t('bankProducts.productDetails.reportProblem')}
      </Button>
      {isDownloadAvailable ? (
        <Button>
          {isPending ? (<Loader size={ 16 } />) : (
            <Download style={ { color: briksTheme.colors['base.white'] } } />
          )}
          {t('bankProducts.productDetails.download')}
        </Button>
      ) : null}
    </>
  );
};

export default BankProductActions;
